import Header from './Headers';
import Const from '../util/Constants';
import DateUtil from '../util/Util';
import Config from '../config/config';

class AttendanceAPI {

  static ModelNo = 47;

  static list = (list, success, failure, logout) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    
    fetch(Config.app.link + 'api/attendance/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static getCheckinStatus = (user, success, failure, logout) => {
    let date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    let value = DateUtil.dateToServerDateTime(date);
    date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);
    date.setMilliseconds(999);
    value += Const.Opt + DateUtil.dateToServerDateTime(date);

    const body = { 
      filter: [{field: 'attendance_day', condition: 'in', value }, { field: 'user_id', condition: 'in', value: `~${user}~`}], 
      page: 1, perPage: 10, sorting: { field: 'attendance_day', order: -1 }
    };
    fetch(Config.app.link + 'api/attendance/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static count = (list, success, failure, logout) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const body = { filter: filter, page: page, perPage: perPage };
    
    fetch(Config.app.link + 'api/attendance/list/count', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static get = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/attendance/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static save = (body, success, failure, logout) => {
    fetch(Config.app.link + 'api/attendance/add-edit', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/attendance/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }
}

export default AttendanceAPI;